import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const LocationContext = createContext();

export const LOCATIONS = ['Princeton', 'Fort Lee', 'Palisades Park'];

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};

export const LocationProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState(() => {
    // Try to load from cookie
    return Cookies.get('pickupLocation') || null;
  });

  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);
  const [onConfirmCallback, setOnConfirmCallback] = useState(null);

  useEffect(() => {
    // Show modal if no location is selected
    if (!selectedLocation) {
      setShowLocationModal(true);
    }
  }, [selectedLocation]);

  const updateLocation = (location) => {
    setSelectedLocation(location);
    // Save to cookie (expires in 30 days)
    Cookies.set('pickupLocation', location, { expires: 30 });
  };

  const requestLocationChange = (newLocation, onConfirm) => {
    setPendingLocation(newLocation);
    setOnConfirmCallback(() => onConfirm);
    setShowChangeModal(true);
  };

  const handleConfirmChange = () => {
    if (onConfirmCallback) {
      onConfirmCallback();
    }
    if (pendingLocation) {
      updateLocation(pendingLocation);
    }
    setShowChangeModal(false);
    setPendingLocation(null);
    setOnConfirmCallback(null);
  };

  const handleCancelChange = () => {
    setShowChangeModal(false);
    setPendingLocation(null);
    setOnConfirmCallback(null);
  };

  const value = {
    selectedLocation,
    updateLocation,
    showLocationModal,
    setShowLocationModal,
    showChangeModal,
    requestLocationChange,
    handleConfirmChange,
    handleCancelChange,
    locations: LOCATIONS,
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};
